module.exports = __webpack_public_path__ + "static/media/car.d2e5a02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car.png
// module id = 1582
// module chunks = 0